export const noop = () => {
    console.log("Empty function");
};
